import { Component, OnInit } from '@angular/core';
import { DownloadSectionComponent } from '../../components/download-section/download-section.component';
import { SliderComponent } from '../../components/slider/slider.component';
import { DesignerCardsComponent } from '../../components/designer-cards/designer-cards.component';
import { CampaignBannerComponent } from '../../components/campaign-banner/campaign-banner.component';
import { MyKnowledgeService, HotTopicItem } from '../../services/my-knowledge.service';
import { CountrySelectionService } from '../../services/country-selection.service';
import { CampaignService, CampaignConfig } from '../../services/campaign.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [DownloadSectionComponent, SliderComponent, DesignerCardsComponent, CampaignBannerComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {
  sliderItems: HotTopicItem[] = [];
  selectedCountry: any;
  activeCampaigns: CampaignConfig[] = [];

  constructor(
    private myKnowledgeService: MyKnowledgeService,
    private countrySelectionService: CountrySelectionService,
    private campaignService: CampaignService
  ) {}

  ngOnInit(): void {
    this.countrySelectionService.selectedCountry$.subscribe(country => {
      this.selectedCountry = country;
      
      // Fetch active campaigns dynamically whenever the country changes
      if (country?.name) {
        this.campaignService.getActiveCampaigns(country.name).subscribe(campaigns => {
          this.activeCampaigns = campaigns;
        });
      } else {
        this.activeCampaigns = [];
      }
    });

    this.myKnowledgeService.getHotTopics().subscribe(data => {
      console.log('Slider Data:', data);
      this.sliderItems = data;
    });
  }
}